import React, { useState, useRef } from 'react'
import { Presentation } from 'pobble-components/dist/presentation'
import { useReactToPrint } from 'react-to-print'
import styles from './use-presentation-print.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'
import { createPortal } from 'react-dom'
import posthog from 'posthog-js'
import { apiClient } from 'pobble-components/dist/api'

const usePresentationPrint = (data, { onAfterPrint, test } = {}) => {
  const [printInProgress, setPrintInProgress] = useState(false)
  const componentRef = useRef(null)
  const handlePrint = useReactToPrint({
    onAfterPrint: () => {
      apiClient.post('/v3/me/activated_with_product', {
        type: 'feature'
      })
      posthog.capture('activate', { type: 'feature' })
      posthog.capture('After presentation print')
      setPrintInProgress(false)
      onAfterPrint && onAfterPrint()
    },
    copyStyles: true,
    pageStyle:
      '@page { size: A4 landscape;  margin: 0mm; } @media print { body { -webkit-print-color-adjust: exact; color-adjust: exact; } }"',
    content: () => componentRef.current
  })
  const print = () => {
    setPrintInProgress(true)
    if (!test) {
      setTimeout(handlePrint, 3000)
    }
  }
  const PrintComponent = injectSheet(styles)(({ classes }) => {
    return !printInProgress
      ? null
      : createPortal(
          <div
            className={classNames(classes.container, { [classes.test]: test })}
            ref={componentRef}>
            <Presentation
              slideHolderClassName={classes.slideHolder}
              slideContainerClassName={classes.slideContainer}
              multiSlides
              printMode
              containerRef={componentRef}
              data={data}>
              {({ slides }) => slides}
            </Presentation>
          </div>,
          document.body
        )
  })
  return { PrintComponent, print, printInProgress }
}

export default usePresentationPrint
